import { Color } from '../hooks/use-game'
import blueHexagonImage from '../assets/images/hexagon-blue.png'
import yellowHexagonImage from '../assets/images/hexagon-yellow.png'
import redHexagonImage from '../assets/images/hexagon-red.png'
import purpleHexagonImage from '../assets/images/hexagon-purple.png'
import greenHexagonImage from '../assets/images/hexagon-green.png'
import blueStarImage from '../assets/images/star-blue.png'
import yellowStarImage from '../assets/images/star-yellow.png'
import redStarImage from '../assets/images/star-red.png'
import purpleStarImage from '../assets/images/star-purple.png'
import greenStarImage from '../assets/images/star-green.png'

export function getColor(color: Color): string {
  switch (color) {
    case Color.BLUE:
      return '#00b3Ec'
    case Color.YELLOW:
      return '#ffd817'
    case Color.RED:
      return '#f33d35'
    case Color.PURPLE:
      return '#682b92'
    case Color.GREEN:
      return '#2cb344'
    default:
      return ''
  }
}

export function getHexagonImage(color: Color): string {
  switch (color) {
    case Color.BLUE:
      return blueHexagonImage
    case Color.YELLOW:
      return yellowHexagonImage
    case Color.RED:
      return redHexagonImage
    case Color.PURPLE:
      return purpleHexagonImage
    case Color.GREEN:
      return greenHexagonImage
    default:
      return ''
  }
}

export function getStarImage(color: Color): string {
  switch (color) {
    case Color.BLUE:
      return blueStarImage
    case Color.YELLOW:
      return yellowStarImage
    case Color.RED:
      return redStarImage
    case Color.PURPLE:
      return purpleStarImage
    case Color.GREEN:
      return greenStarImage
    default:
      return ''
  }
}
